import { ShipAddressFields } from "@types-runway/admin";

export const emptyAddressFields: ShipAddressFields = {
  street: "",
  secondary: "",
  city: "",
  state: "",
  postalCode: "",
};

// The form's values for a saved address, keeping its id so that saving updates it in place.
export const toAddressFields = (address: {
  id?: string;
  street: string;
  secondary?: string | null;
  city: string;
  state: string;
  postalCode: string;
}): ShipAddressFields => ({
  id: address.id,
  street: address.street,
  secondary: address.secondary ?? "",
  city: address.city,
  state: address.state,
  postalCode: address.postalCode,
});

// Street, City, State and ZIP code must have a value before an address can be saved (SHIPUI-R30).
export const isAddressComplete = (fields: ShipAddressFields) =>
  [fields.street, fields.city, fields.state, fields.postalCode].every(
    (value) => value.trim() !== ""
  );
